import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAlertDialog } from 'shared';
import { BodyText } from 'vopay';

// POST /elinx rejects a duplicate with RESOURCE_ALREADY_EXISTS and only names the matched
// request inside the message: "A request with ID 42 is currently active. To override and resend, include an 'IdempotencyKey'."
const DUPLICATE_REQUEST_PATTERN = /request with ID (\d+) is currently active/i;

export const DuplicateElinxRequestDialog = () => {
  const history = useHistory();
  const alertDialog = useAlertDialog();
  const { t } = useTranslation('translations', { keyPrefix: 'Hooks.DuplicateElinxRequestDialog' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  const showIfDuplicateRequest = (err: unknown) => {
    const requestId = err instanceof Error ? DUPLICATE_REQUEST_PATTERN.exec(err.message)?.[1] : undefined;
    if (!requestId) return false;

    const viewRequest = () => history.push(`/elinx-history/details/${requestId}`);

    void alertDialog
      .error(
        t('title', { defaultValue: 'Duplicate request' }),
        <BodyText style={{ fontFamily: 'var(--fontFamily)', width: '340px' }}>
          {t('message', {
            defaultValue:
              "This request matches an active eLinx {{requestId}} for the same contact and amount, so it wasn't sent.",
            requestId,
          })}
        </BodyText>,
        {
          abortLabel: tGlobal('Buttons.cancel', { defaultValue: 'Cancel' }),
          confirmLabel: t('viewRequest', { defaultValue: 'View Request' }),
        },
      )
      .then((result) => {
        if (result === 'confirm') viewRequest();
      });

    return true;
  };

  return { showIfDuplicateRequest };
};
